import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import styles from "./PerformanceChart.module.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const PerformanceChart = ({ data, title = "Performance" }) => {
  // Safety check for data
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <div className={styles.chartContainer}>
        <h3 className={styles.chartTitle}>{title}</h3>
        <div className={styles.noData}>No data available</div>
      </div>
    );
  }

  const getColor = (value) => {
    const val = parseFloat(value) || 0;
    if (val >= 80) return "#28a745";
    if (val >= 60) return "#f57c00";
    return "#dc3545";
  };

  const safeValue = (value) => {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  };

  const chartData = {
    labels: data.map((item) => item.label || "Unknown"),
    datasets: [
      {
        label: "Completion %",
        data: data.map((item) => safeValue(item.value)),
        backgroundColor: data.map((item) => getColor(item.value)),
        borderRadius: 4,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const value = parseFloat(context.parsed.x) || 0;
            return `${value.toFixed(1)}% completion`;
          },
        },
      },
      datalabels: {
        display: true,
        color: "#2d3748",
        font: {
          family: "Imprima",
          size: 13,
          weight: 600,
        },
        anchor: "end",
        align: "end",
        formatter: (value) => `${value.toFixed(2)}`,
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        max: 100,
        ticks: {
          callback: (value) => `${value}%`,
          font: {
            family: "Imprima",
            size: 12,
          },
          color: "#2d3748",
        },
        grid: {
          color: "#e2e8f0",
        },
      },
      y: {
        ticks: {
          font: {
            family: "Imprima",
            size: 13,
            weight: 500,
          },
          color: "#2d3748",
        },
        grid: {
          display: false,
        },
      },
    },
  };

  return (
    <div className={styles.chartContainer}>
      <h3 className={styles.chartTitle}>{title}</h3>
      <div className={styles.horizontalBarWrapper}>
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
};

export default PerformanceChart;
